
import { z } from "zod";

export const InvoiceStatusValues = ["PAID", "PARTIAL", "PENDING_APPROVAL", "REJECTED_INTERNALLY", "UNPAID", "VOIDED"] as const;
export const InvoiceStatusSchema = /* @__PURE__ */ z.enum(InvoiceStatusValues);
export const InvoiceStatus: (typeof InvoiceStatusSchema)["enum"] = { "PAID": "PAID", "PARTIAL": "PARTIAL", "PENDING_APPROVAL": "PENDING_APPROVAL", "REJECTED_INTERNALLY": "REJECTED_INTERNALLY", "UNPAID": "UNPAID", "VOIDED": "VOIDED" };
export type InvoiceStatus = (typeof InvoiceStatusValues)[number];
export const InvoiceStatusDisplayNames = { "PAID": "Paid",
"PARTIAL": "Partial",
"PENDING_APPROVAL": "Pending Approval",
"REJECTED_INTERNALLY": "Rejected Internally",
"UNPAID": "Unpaid",
"VOIDED": "Voided", } satisfies Record<InvoiceStatus, string>;
